import { Route, Routes } from 'react-router-dom';
import AdminPage from './components/admin/AdminPage';
import CreateNewAdmin from './components/admin/CreateNewAdmin';
import Client from './components/clients/Client';
import Nav from './components/navigation/Nav';
import Pharmacie from './components/pharmacie/Pharmacie';

function App() {
  return (
    <div style={{overflowX:'hidden'}}>
      <Routes>
        <Route path='/*' element={<Nav />} />
        <Route path='/pharmacie/*' element={<Pharmacie/>} />
        <Route path='/admin/*' element={<AdminPage/>} />
        <Route path="/client/*" element={<Client/>} />
        <Route path='/admin/createAdmin/*' element={<CreateNewAdmin/>} />
      </Routes>
    </div>
  );
}
export default App;
